import React from "react";
import { SHOPFRONTS_VIEW_ALL_EVENT_LABEL } from "web/react/components/navigation/shopfronts.constants";
import { Heading } from "web/react/emo/heading";
import { ListItem } from "web/react/emo/list-item";
import { Text } from "web/react/emo/text";
import { View } from "web/react/emo/view";
import { MenuLinkSerializer, SubMenuSerializer } from "web/types/serializers";
import * as styles from "./shopfronts-menu.css";

export const SHOPFRONTS_MAX_ITEMS =
    styles.SHOPFRONTS_MAX_COLUMNS * styles.SHOPFRONTS_ROWS_PER_COLUMN;

export function getVisibleShopfrontsLinks(links: MenuLinkSerializer[]): MenuLinkSerializer[] {
    const viewAllLink = links.find((link) => link.event_label === SHOPFRONTS_VIEW_ALL_EVENT_LABEL);
    const shopfrontLinks = links.filter(
        (link) => link.event_label !== SHOPFRONTS_VIEW_ALL_EVENT_LABEL
    );

    // If shopfronts fit in the grid, omit View All. Otherwise truncate
    // and put View All as the last item in the last column.
    if (!viewAllLink || shopfrontLinks.length <= SHOPFRONTS_MAX_ITEMS) {
        return shopfrontLinks;
    }

    return [...shopfrontLinks.slice(0, SHOPFRONTS_MAX_ITEMS - 1), viewAllLink];
}

export interface ShopfrontsMenuProps {
    category: SubMenuSerializer;
    onLinkClick: (link: MenuLinkSerializer) => void;
}

export function ShopfrontsMenu({ category, onLinkClick }: ShopfrontsMenuProps): React.ReactElement {
    const items = getVisibleShopfrontsLinks(category.links);

    return (
        <div className={styles.menu}>
            <div className={styles.shopfronts}>
                <View marginTop="xs" height="full">
                    <View paddingLeft="sm">
                        <Heading textStyle="subhead" as="h2">
                            {category.display_name}
                        </Heading>
                    </View>
                    <View marginTop="md" height="full">
                        <ul className={styles.shopfrontsList}>
                            {items.map((link) => (
                                <ListItem
                                    as="a"
                                    href={link.url}
                                    key={link.url}
                                    onClick={() => onLinkClick(link)}
                                >
                                    <Text
                                        textStyle="body-s"
                                        underline={
                                            link.event_label === SHOPFRONTS_VIEW_ALL_EVENT_LABEL
                                        }
                                    >
                                        {link.text}
                                    </Text>
                                </ListItem>
                            ))}
                        </ul>
                    </View>
                </View>
            </div>
        </div>
    );
}
